import React from 'react';
import {Dropdown} from 'semantic-ui-react';
import Services from 'mpm-services';
import { useState } from 'react';
import { useRef } from 'react';


const ChangeEntiteRattachement = () => {

    const [entite, setEntite] = useState('EXTRANET');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const listRef = useRef();
    React.useEffect(() => {
        Services.Refs.findAll()
        .then(response => {
            setOptions(response);
            setLoading(false);
        })
        .catch(error => {
            setError(true);
            setLoading(false);
        });
    },[]);
    
    
   const handleChange = (e, { value }) => {
       setLoading(true);
       setError(false);
       setEntite(value);
       Services.Refs.update(12, {
           entite
       }).then(response => {
           setLoading(false);
       }).catch(error => {
           setLoading(false);
           setError(true);
       })
   };

    return (
        <Dropdown
            ref={listRef}
            style={{marginTop: '2em'}}
            fluid
            onChange={handleChange}
            options={options}
            selection
            value={entite}
            loading={loading}
            error={error}
        />
    );
}


export default ChangeEntiteRattachement;